module.exports = __webpack_public_path__ + "src/assets/images/volums/sound/volum_circle3.png?8efc540b0b206a39363665fa25645d80";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/sound/volum_circle3.png
// module id = 667
// module chunks = 0